import MainComponent from "components/Main";

import Calendar from "../../../../components/Calendar";

export default class CalendarAdvanced extends MainComponent {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            value: new Date(),
            selected: new Date(),
        };
    }

    onChange(value) {
        this.setState({ value, selected: value });

        if (this.props.onChange)
            this.props.onChange(value);
    }

    onCalendarFirstMonthChange(value) {
        this.setState({ value });
    }

    render() {
        const { dateMode } = this.props;
        const { value, selected } = this.state;

        let interval = 1;
        let date = selected;
        if (dateMode === "week") {
            const { startOfWeek } = this._helper.date.getWeek(selected);
            date = startOfWeek;
            interval = 7;
        } 

        return (
            <Calendar
                value={value}
                selected={date}
                dateMode={dateMode}
                interval={interval}
                onChange={this.onChange.bind(this)}
                onMonthChange={this.onCalendarFirstMonthChange.bind(this)}
            />
        );
    }
}
